import { render, staticRenderFns } from "./CompanyProfileIndex.vue?vue&type=template&id=4d83100a&scoped=true&"
import script from "./CompanyProfileIndex.vue?vue&type=script&lang=ts&"
export * from "./CompanyProfileIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83100a",
  null
  
)

export default component.exports